// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  enableLogs: false,
  disableSite: false,

  /**
   * Feature: Authentication
   *
   * Defines Environments related
   * to Authentication module
   */
  defaultUrl: 'auth/login',
  enableRegistration: false,

  /**
   * Static Resources
   */
  logo: '/assets/img/strata-logo.png',
  name: 'Real Estate Investment Platform',
  email: 'admin@yourcompany.com',

  /**
   * Prefixes
   */
  apiHost: 'https://snjs.ncome.in/',
  host: 'https://myescrow.castler.com',
  apiPrefix: 'https://snjs.ncome.in/api/v1',
  urlPortalPrefix: 'portal',
  urlAdminPrefix: 'super-admin',

  /**
   * Misc Settings
   */
  captchaDisable: true,
  secretKey: 'secret_key',
  defaultItemsPerPage: 10,
  decryptKey: false,
  canAdminViewUserOptions: false,

  /**
   * Feature: Challan/I-Sure
   */
  challanPayTo: 'NCOME TECH SOLUTIONS PVT LTD',

  /**
   * Feature: Notification
   */
  enableWHATSAPP: false,

  /**
   * Feature: Escrow Pages
   */
  escrowPagesVerificationFields: [],
  escrowPagesRequiredFields: ['pan', 'bank', 'aadhaar', 'custom'],
  /**
   * Feature: Razorpay
   */
  razorpayKey: 'rzp_live_VyTg1cbQ9c10VO',
  razorpayLogo: '/assets/img/Castler_logo.png',

  dateDifferentialInMonth: 1,
  maxNumberOfNotes: 15,

  NOTICE_MODAL_VIEWED: 'noticeModalViewed',
  NOTICE_MODAL_SHOW_AGAIN: 'noticeShowAgain',
  LAST_NOTICE_ID: 'lastNoticeId',

  /**
   * FOr Merchant activate/deactivate OTP verification
   */
  superAdminMobile: 9560358499,
  effectiveBalanceDelay: 500,

  /**
   *
   */

    maxApprovals: 500,
    maxTransfersinBulk: 500,
     /**
     * For X API Generation
     */
    enableXAPIKey: 'chandan@castler.com',
        /**
     * Dashboard
     */
    noOfDaysSwitch: 28,
    maxSize: 10 * 1024 * 1024,
    depositMaxAmount: 1000000000,
    adminEmail:"sumit.kumar@castler.com,rakesh@castler.com",
    ReportServiceHost: "https://snjs-service.ncome.in/report/"
    
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
